// extracted by mini-css-extract-plugin
export default {"pageHeader":"UsersListHeader_pageHeader__sNn9l","searchMobile":"UsersListHeader_searchMobile__TaPnz","searchDesktop":"UsersListHeader_searchDesktop__BLL4m"};